module.exports = __webpack_public_path__ + "static/media/airtable_ai.02961530.png";